import React, { useState } from 'react';

export default function useInput({ type, ...rest }) {
	const [value, setValue] = useState('');
	const input = <input value={value} onChange={e => setValue(e.target.value)} type={type} {...rest} />;
	return [value, input, setValue] as const;
}
